import {BoardContainer, TitleContainer,} from "../../assets/GlobalStyles";
import ReportsMedia from "./Media";
import ReportsInventory from "./ReportsInventory";
import ReportsPeriod from "./Period";
import ReportsAdExchange from "./AdExchange";
import {useParams, useSearchParams} from "react-router-dom";
import ScrollToTop from "../../components/common/ScrollToTop";
import React, {useEffect, useState} from "react";
import ReportsHourPeriod from "./PeriodbyHour";
import styled from "styled-components";
import {selectUserCategories} from "../../services/platform/ManageUserCategoryAxios";

export default function Reports(){
  const params = useParams()
  const [searchParams] = useSearchParams()
  const [mediaCategoryName, setMediaCategoryName] = useState("전체 매체")

  useEffect(() => {
    if (params.id !== "reportsMedia") return
    const categoryId = searchParams.get("categoryId")
    if (!categoryId) {
      setMediaCategoryName("전체 매체")
      return
    }
    selectUserCategories()
      .then(categories => {
        const selectedCategory = categories.find(category => String(category.id) === String(categoryId))
        setMediaCategoryName(selectedCategory?.label || "선택된 카테고리")
      })
      .catch(() => setMediaCategoryName("선택된 카테고리"))
  }, [params.id, searchParams])

  return(
    <ReportsPage>
      <ScrollToTop/>
      <BoardContainer>
        <TitleContainer>
          <ReportTitleRow>
            <h1>보고서</h1>
            {params.id === "reportsMedia" && <CategoryBadge>{mediaCategoryName}</CategoryBadge>}
          </ReportTitleRow>
        </TitleContainer>
        {/* 일자별보고서 */}
        {params.id === 'reports' && <ReportsPeriod/>}
        {params.id === 'reportsHour' && <ReportsHourPeriod/>}
        {/* 매체별보고서 */}
        {params.id === 'reportsMedia' && <ReportsMedia/>}
        {/* 지면별보고서 */}
        {params.id === 'reportsInventory' && <ReportsInventory/>}
        {/* 외부연동수신보고서 */}
        {params.id === 'reportsAdExchange' && <ReportsAdExchange/>}
      </BoardContainer>
    </ReportsPage>
  )
};

const ReportsPage = styled.main`
  ${BoardContainer} {
    min-width: 0;
    margin: 0;
    border-radius: 0;
    background: transparent;
  }

  ${TitleContainer} h1 {
    margin: 0;
    color: rgb(32, 36, 43);
    font-size: var(--font-size-24);
    font-weight: 750;
    letter-spacing: -.025em;
  }
`;

const ReportTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CategoryBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border: 1px solid var(--color-primary-border);
  border-radius: 999px;
  background: var(--color-primary-soft);
  color: var(--color-primary-strong);
  font-size: var(--font-size-12);
  font-weight: 750;
  white-space: nowrap;
`;
